"use strict";

document.addEventListener("DOMContentLoaded", () => {
	const drawer = document.querySelector(".drawer");
	if (drawer) new DrawerMenu();

	const modal = document.querySelectorAll(".l-modal[id]");
	for (let el of modal) new SetupModalUi(el);

	const faqEls = document.querySelectorAll(".c-faq .item");
	faqEls.forEach((el, i) => {
		const head = el.querySelector("dt button");
		const body = el.querySelector("dd");
		new SetupDetails(head, body, i);
	});

	const detailsEls = document.querySelectorAll(".c-details");
	detailsEls.forEach((el, i) => {
		const head = el.querySelector(".c-details_summary");
		const body = el.querySelector(".c-details_content");
		new SetupDetails(head, body, i);
	});

	// 商品ラインナップ
	const splide = document.querySelectorAll(".splide");
	for (let el of splide) new SetupSplide(el);

	var timer = 0;
	window.addEventListener("resize", () => {
		if (timer !== false) clearTimeout(timer);
		timer = setTimeout(() => {
			window.dispatchEvent(new Event("resized"));
		}, 200);
	});
});

class SetupDetails {
	constructor(head, body, i) {
		this.head = head;
		this.body = body;
		this.setup("details-" + i);
	}
	setup(id) {
		this.isOpened = false;
		this.body.id = id;
		this.body.inert = true;
		this.head.ariaExpanded = false;
		this.head.setAttribute("aria-controls", id);

		let icon = '<span class="ico minus"></span>';
		this.head.insertAdjacentHTML("beforeend", icon);

		this.head.addEventListener("click", () => {
			!this.isOpened ? this.faqOpen() : this.faqClose();
		});
		this.body.addEventListener("transitionend", () => {
			this.body.classList.remove("is-motion");
			this.body.style.height = "";
		});
	}
	faqOpen() {
		this.isOpened = true;
		this.body.inert = false;
		this.head.ariaExpanded = true;

		this.body.style.height = 0;
		const openHeight = this.body.firstElementChild.offsetHeight;
		this.head.classList.add("is-open", "is-motion");

		setTimeout(() => {
			this.body.classList.add("is-open", "is-motion");
			this.body.style.height = openHeight + "px";
		}, 20);
	}
	faqClose() {
		this.isOpened = false;
		this.body.inert = true;
		this.head.ariaExpanded = false;

		const openHeight = this.body.firstElementChild.offsetHeight;
		this.head.classList.remove("is-open");
		this.head.addEventListener(
			"transitionend",
			() => {
				this.head.classList.remove("is-motion");
			},
			{ once: true },
		);

		setTimeout(() => {
			this.body.classList.replace("is-open", "is-motion");
			this.body.style.height = 0;
		}, 20);
	}
}

/**
 * Modal contents
 * @param {element} el = モーダルコンテンツ (data-modal="{targetElementId}")
 */
class SetupModalUi {
	constructor(modal) {
		this.modal = modal;
		this.closer = modal.querySelector(".modal_close");
		this.container = modal.querySelector(".modal_container");

		this.setup();
	}
	setup() {
		const id = this.modal.id;

		// 商品リンクデータを保持する
		this.purchaseData = null;
		if (this.modal.dataset.json) {
			this.purchaseData = JSON.parse(this.modal.dataset.json);
			this.modal.removeAttribute("data-json");
		}

		const openerEls = document.querySelectorAll(`[data-modal="${id}"]`);
		for (let opener of openerEls) {
			opener.ariaExpanded = false;
			opener.setAttribute("aria-controls", id);
			opener.addEventListener("click", (e) => this.modalOpen(e));
		}
		this.modal.inert = true;

		this.utility();
	}
	utility() {
		// モーダル開くモーションに影響させない
		const links = this.container.querySelectorAll("a, button");
		for (let link of links) {
			link.addEventListener("transitionend", (e) => {
				e.stopPropagation();
			});
		}

		// コンテンツ外をクリックしたら閉じる
		this.modal.addEventListener("click", (e) => {
			if (this.isOpened && !e.target.closest(".modal_container")) {
				this.modalClose();
			}
		});

		// モーダル内でEscキーを押したら閉じる
		this.modal.addEventListener("keydown", (e) => {
			if (this.isOpened && e.code === "Escape") {
				this.modalClose();
			}
		});

		// 閉じるボタン上でのShift+Tabキーを押したら最後のリンクへフォーカス
		this.closer.addEventListener("keydown", (e) => {
			if (this.isOpened && e.shiftKey && e.code === "Tab" && links[0]) {
				e.preventDefault();
				links[links.length - 1].focus();
			}
			if (this.isOpened && !e.shiftKey && e.code === "Tab" && !links[0]) {
				e.preventDefault();
			}
		});

		// 最後のリンク上でTabキーを押したら閉じるボタンへフォーカス
		if (links[0]) {
			links[links.length - 1].addEventListener("keydown", (e) => {
				if (this.isOpened && !e.shiftKey && e.code === "Tab") {
					e.preventDefault();
					this.closer.focus();
				}
			});
		}
	}
	modalOpen(e) {
		const opener = e.currentTarget;
		const id = opener.dataset.modal;

		const openedModal = document.querySelector(
			`.l-modal:not(#${id}).is-active`,
		);
		if (openedModal) {
			this.doClose(openedModal, true);
		}
		const type = opener.dataset.modalPurchase || "purchase";
		const modal = document.getElementById(id);
		if (!modal) return;

		this.isOpened = true;
		this.curOpener = opener;

		const underlay = modal.querySelector(".modal_underlay");
		const container = modal.querySelector(".modal_container");
		const closer = modal.querySelector(".modal_close");
		closer.addEventListener("click", () => this.modalClose(), { once: true });

		modal.classList.add("is-active");
		modal.dataset.type = type;

		// 商品リンクを挿入する
		if (this.purchaseData) {
			this.insertPpurchaseLink(modal, type);
		}

		// モーダルの中にタブコンテンツがあったら実装
		const tabsEl = modal.querySelector(".c-tabs");
		if (tabsEl) {
			new SetupTabsUi(tabsEl);

			// data-open-tab があったら該当タブを開いておく
			const openTab = opener.dataset.openTab;
			if (openTab)
				modal.querySelector(`.tab_button[href="#${openTab}"]`)?.click();
		}
		opener.ariaExpanded = true;
		modal.inert = false;

		setTimeout(() => {
			for (let relation of [closer, underlay, container]) {
				relation.classList.add("is-open", "is-motion");
			}
			closer.focus({ focusVisible: true });
		}, 20);
	}
	insertPpurchaseLink(modal, type) {
		const data = this.purchaseData[type];
		const container = modal.querySelector(".modal_container");
		const isArray = Array.isArray(data);
		let html = "";
		if (isArray) {
			for (let d of data) {
				html += `<div class="p-purchase modal_contents">`;
				html += this.returnItem(d);
				html += `</div>`;
			}
		} else {
			html += `<div class="p-purchase modal_contents">`;
			html += this.returnItem(data);
			html += `</div>`;
		}
		container.innerHTML = html;
	}
	modalClose() {
		const modal = this.closer.closest(".l-modal");
		this.doClose(modal);
	}
	doClose(modal, isReplace = false) {
		this.isOpened = false;

		if (!isReplace) {
			this.curOpener.focus({ focusVisible: true });
			this.curOpener.ariaExpanded = false;
			modal.inert = true;
		}

		const underlay = modal.querySelector(".modal_underlay");
		const container = modal.querySelector(".modal_container");
		const closer = modal.querySelector(".modal_close");

		for (let relation of [closer, underlay, container]) {
			relation.classList.replace("is-open", "is-motion");
		}
		container.addEventListener(
			"transitionend",
			(e) => {
				modal.classList.remove("is-active");
			},
			{ once: true },
		);
	}
	returnItem(d) {
		console.log(d);
		let html = "";
		html += `<div class="product_image">`;
		html += `<figure class="image"><img src="${d.photo.src}" alt="" width="${d.photo.width}" height="${d.photo.height}"></figure>`;
		html += `</div>`;
		html += `<h2 class="product_title">${d.title}</h2>`;
		html += `<dl class="product_links -online">`;
		html += `<dt class="lead">ネスレ ヘルスサイエンス オンラインショップで購入</dt>`;
		for (let n of d.nestle) {
			html += `<dd class="item"><a href="${n.url}" target="_blank" rel="noopener" class="c-purchase -${n.id}">${n.title}</a></dd>`;
		}
		html += `</dl>`;
		html += `<ul class="product_links -other">`;
		for (let l of d.links) {
			html += `<li class="item"><a href="${l.url}" target="_blank" rel="noopener" class="c-purchase -${l.id}">${l.title}</a></li>`;
		}
		html += `</ul>`;
		return html;
	}
}

/**
 * Tabs contents
 * @param {element} el = タブコンテンツ (モバイル時はアコーディオン)
 */
class SetupTabsUi {
	constructor(el) {
		if (el.dataset.setted) return;
		el.dataset.setted = true; // data属性で実装済みフラグ

		this.switch();

		this.tabsData = {};
		this.elRect = el.getBoundingClientRect();
		const tabs = el.querySelectorAll(".tab_button");
		for (let tab of tabs) this.setup(tab);

		// 最初に開いておくタブ
		const initialTab = tabs[0];
		const initiaId = initialTab.getAttribute("href").slice(1);
		const initiaContent = this.tabsData[initiaId].content;
		initialTab.classList.add("is-active");
		initiaContent.classList.add("is-active", "is-open");
		initiaContent.inert = false;
		this.curRect = initiaContent.getBoundingClientRect();
		this.tabsData[initiaId].isOpened = true;
		this.openedId = initiaId;

		// デスクトップ<->モバイルでUI切り替え
		window.addEventListener("resized", () => this.switch());
	}
	switch() {
		this.isMobile = window.matchMedia("(max-width:767.98px)").matches;
	}
	setup(tab) {
		const id = tab.getAttribute("href").slice(1);
		const content = document.getElementById(id);

		this.tabsData[id] = { tab, content, isOpened: false };

		tab.ariaExpanded = false;
		tab.setAttribute("aria-controls", id);
		content.inert = true;

		tab.addEventListener("click", (e) => this.onToggle(e));
	}
	onToggle(e) {
		e.preventDefault();

		const id = e.currentTarget.getAttribute("href").slice(1);

		if (!this.isMobile) {
			// デスクトップは開いてるタブと違ったら切り替え
			if (this.openedId !== id) this.tabOpen(id);
		} else {
			// モバイルは閉じてたら開き、開いてたら閉じる
			if (!this.tabsData[id].isOpened) {
				this.tabOpen(id);
			} else {
				this.tabClose(id);
			}
		}
	}
	tabOpen(id) {
		this.tabsData[id].isOpened = true;
		const tab = this.tabsData[id].tab;
		const content = this.tabsData[id].content;

		const tabRect = tab.getBoundingClientRect();
		const curHeight = this.curRect.bottom - tabRect.bottom; // タブの底からコンテンツの底までの距離

		// デスクトップはここで今のタブを閉じる
		if (!this.isMobile) {
			this.tabClose(this.openedId);
		}

		// 新しいタブを開く
		tab.classList.add("is-active");
		tab.ariaExpanded = true;
		content.classList.add("is-active");
		content.inert = false;

		const newRect = content.getBoundingClientRect();
		const newHeight = newRect.bottom - tabRect.bottom;

		if (!this.isMobile) {
			// 今のコンテンツの高さをセット、同時に前のコンテンツは高さ0に
			content.style.height = curHeight + "px";
			this.tabsData[this.openedId].content.style.height = 0;
		} else {
			// モバイルは高さ0からスタート
			content.style.height = 0;
		}
		setTimeout(() => {
			content.classList.add("is-open", "is-motion");
			content.style.height = newHeight + "px";

			content.addEventListener(
				"transitionend",
				(e) => {
					e.stopPropagation();
					content.classList.remove("is-motion");
					content.style.height = "";
				},
				{ once: true },
			);
		}, 20);

		// 開いてるタブに更新
		this.openedId = id;
		this.selectedTab = tab;
		this.openedContent = content;
		this.curRect = newRect;
	}
	tabClose(id) {
		this.tabsData[id].isOpened = false;
		const tab = this.tabsData[id].tab;
		const content = this.tabsData[id].content;

		tab.classList.remove("is-active");
		tab.ariaExpanded = false;
		content.inert = true;

		if (this.isMobile) {
			// モバイルは今のコンテンツの高さをセット後、モーションして0へ
			const tabRect = tab.getBoundingClientRect();
			const curHeight = this.curRect.bottom - tabRect.bottom;
			content.style.height = curHeight + "px";
			content.classList.replace("is-open", "is-motion");
			content.style.height = 0;
		} else {
			content.classList.replace("is-open", "is-motion");
		}

		content.addEventListener(
			"transitionend",
			(e) => {
				e.stopPropagation();
				content.classList.remove("is-motion", "is-active");
				content.style.height = "";
			},
			{ once: true },
		);
	}
}

/**
 * Splide
 */
class SetupSplide {
	constructor(el) {
		this.splide = null;
		this.init(el);
	}
	init(el) {
		const firstRect = el
			.querySelector(".splide__slide:first-child")
			.getBoundingClientRect();
		const lastRect = el
			.querySelector(".splide__slide:last-child")
			.getBoundingClientRect();
		const slideWidth = lastRect.right - firstRect.left;
		if (!this.splide) this.setup(el);
	}
	setup(el) {
		this.splide = new Splide(el, {
			flickPower: 200,
			perMove: 3,
			flickMaxPages: 1,
			pagination: false,
			mediaQuery: "max",
			breakpoints: {
				767.98: {
					perMove: 1,
					focus: "center",
					trimSpace: true,
				},
			},
		}).mount();

		// Splide.jsのaria-hidden付与を強制解除 (WAI-ARIA警告対策)
		for (let el of this.splide.Components.Elements.slides) {
			el.ariaHidden = false;
		}
		this.splide.on("moved", () => {
			const slides = this.splide.Components.Elements.slides;
			for (let slide of slides) slide.ariaHidden = false;
		});
	}
}

/**
 * Drawer
 */
class DrawerMenu {
	constructor() {
		this.nav = document.querySelector(".nav");
		this.drawer = this.nav.querySelector(".drawer");
		this.navLogo = this.nav.querySelector(".nav_logo");
		this.navContainer = this.nav.querySelector(".nav_container");

		this.nav.id = "navigation";
		this.drawer.ariaLabel = "ナビゲーション";
		this.drawer.setAttribute("aria-conteols", "navigation");

		this.isSettle = false;
		this.onResize();

		this._onResize = this.onResize.bind(this);
		window.addEventListener("resized", this._onResize);
	}
	onResize() {
		this.isMobile = window.matchMedia("(max-width:767.98px)").matches;
		if (this.isMobile) {
			if (!this.isSettle) this.setup();
		} else {
			if (this.isSettle) this.destroy();
		}
	}
	destroy() {
		this.isSettle = false;
		this.drawer.ariaExpanded = "";
		this.drawer.classList.remove("is-open", "is-anim");
		this.nav.classList.remove("is-active");
		this.navContainer.classList.remove("is-open", "is-anim");

		document.removeEventListener("keydown", this._navEscape);
		window.removeEventListener("resized", this._onResize);
	}
	setup() {
		this.isSettle = true;
		this.nav.ariahidden = true;
		this.drawer.ariaExpanded = false;

		// 開閉
		this.drawer.addEventListener("click", () => {
			!this.isOpened ? this.navOpen() : this.navClose();
		});
		this.drawer.addEventListener("animationend", (e) => {
			this.drawer.classList.remove("is-anim");
		});
		this.drawer.addEventListener("transitionend", (e) => {
			e.stopPropagation();
		});
		this.nav.addEventListener("transitionend", (e) => {
			this.navContainer.classList.remove("is-motion");
			if (!this.isOpened) {
				this.nav.classList.remove("is-active");
			}
		});
		this.utility();
	}
	utility() {
		// メニュー開くモーションに影響させない
		const links = this.nav.querySelectorAll("a[href]");
		for (let link of links) {
			link.addEventListener("transitionend", (e) => {
				e.stopPropagation();
			});
		}
		// どこかをクリックしたら閉じる
		this.nav.addEventListener("click", (e) => {
			if (this.isOpened && !e.target.closest(".drawer")) this.navClose();
		});
		// メニュー内で esc キーを押したら閉じる
		this._navEscape = this.navEscape.bind(this);
		document.addEventListener("keydown", this._navEscape);

		// フォーカスをメニューの中に閉じ込める
		this.drawer.addEventListener("keydown", (e) => {
			if (this.isOpened && e.shiftKey && e.code === "Tab") {
				e.preventDefault();
			}
		});
		this.nav.addEventListener("focusout", (e) => {
			if (this.isOpened) {
				if (e.target.closest(".nav") === null) {
					e.preventDefault();
					this.drawer.focus({ focusVisible: true });
				}
			}
		});
	}
	navEscape(e) {
		if (e.code === "Escape" && this.isOpened) {
			this.drawer.focus();
			this.navClose();
		}
	}
	navOpen() {
		this.navContainer.ariahidden = false;
		this.drawer.ariaExpanded = true;

		this.drawer.classList.add("is-open", "is-anim");
		this.nav.classList.add("is-active");

		setTimeout(() => {
			this.isOpened = true;
			this.navContainer.classList.add("is-open", "is-motion");
		}, 20);
	}
	navClose(motion = true) {
		this.isOpened = false;
		this.nav.ariahidden = true;
		this.drawer.ariaExpanded = false;

		this.drawer.classList.replace("is-open", "is-anim");
		this.navContainer.classList.replace("is-open", "is-motion");
	}
}
